import { render, staticRenderFns } from "./mgcPop.vue?vue&type=template&id=5be5bf10&scoped=true"
import script from "./mgcPop.vue?vue&type=script&lang=js"
export * from "./mgcPop.vue?vue&type=script&lang=js"
import style0 from "./mgcPop.vue?vue&type=style&index=0&id=5be5bf10&prod&lang=scss&scoped=true"
import style1 from "./mgcPop.vue?vue&type=style&index=1&id=5be5bf10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be5bf10",
  null
  
)

export default component.exports